import { getCodeVerifier, saveAuthData } from '../utils/storage';

export const SET_ACCESS_TOKEN_DATA = 'SET_ACCESS_TOKEN_DATA';
export const setAccessTokenData = (accessTokenData) => ({
    type: SET_ACCESS_TOKEN_DATA,
    payload: accessTokenData,
});

export const SET_USER_DATA = 'SET_USER_DATA';
export const setUserData = (userData) => ({
    type: SET_USER_DATA,
    payload: userData,
});

export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const setLoggedIn = (isLoggedIn) => ({
    type: SET_LOGGED_IN,
    payload: isLoggedIn,
});

export const fetchToken = (code, navigate, setIsError) => async (dispatch) => {
    try {
        const codeVerifier = getCodeVerifier();
        const params = new URLSearchParams();
        params.append('grant_type', 'authorization_code');
        params.append('client_id', process.env.REACT_APP_IABILET_OAUTH_CLIENT_ID);
        params.append('code', code);
        params.append('code_verifier', codeVerifier);
        params.append('redirect_uri', process.env.REACT_APP_IABILET_OAUTH_REDIRECT_URI);

        const response = await fetch(process.env.REACT_APP_IABILET_OAUTH_TOKEN_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: params,
        });
        if (!response.ok) {
            setIsError(true);
            return;
        }

        const data = await response.json();
        dispatch(setAccessTokenData(data));
        saveAuthData(data);
        dispatch(setLoggedIn(true));

        navigate('/admin');
    } catch (e) {
        setIsError(true);
    }
};
